// Agent\worker\custom\Morrhtechsolutions\src\environments\environment.ts
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  domain: 'https://ai.afrogift.com',
  appDomain: 'https://ai.afrogift.com/Morrhtechsolutions',
  api: 'https://ai.afrogift.com/api/firewall',
  pub_key: '7f2G4iAwNUrJcGe05gNUrJBYZjsGkcAY0LWp9ck0826oA0826wNUrJcAf2G2G4iAnrY0LWp9n',
  serverAddress: '192.168.0.136',
  ipApi: 'https://ipapi.co/json/',
  infurakey: "",
  partnerConnect: 'https://192.168.0.136:1967',
  adminAddress: 'somtobuchi@gmail.com',
  authUrl: 'https://192.168.0.136:1959',
  firewall: 'https://ai.afrogift.com',
   app: 'Afro',
    port: 1949,
  donation: 'https://afrogift-donation.vercel.app',
  appName: 'Morrhtechsolutions',
    tawkexternal: 'https://tawk.to/chat/68b0244fbe8646192a41984e/1j3o0rllg?layout=modern'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

